// extracted by mini-css-extract-plugin
module.exports = {"rewards":"Rewards_rewards__vMFTv","wall":"Rewards_wall__n2e7m","statuettes":"Rewards_statuettes__FXOiC"};